<template>
  <div class="p-condition-container right-container">
    <div class="right-header flex-between">
      <div class="flex-row-start">
        <a
          href="javascript:;"
          class="sign column"
          v-for="(item, index) in tabList"
          :key="index"
          :class="{ active: tabActive == item.code }"
          @click="onSelectTab(item.code)"
          >{{ item.title }}</a
        >
      </div>
      <!-- <div class="flex-row-end">
        <div class="circle"></div>
        <div class="right-header-text">
          作业消息：<span class="num">{{ workTotal }}</span>
        </div>
        <div class="right-header-text">
          系统消息：<span class="num">{{ systemTotal }}</span>
        </div>
      </div> -->
    </div>
    <div class="p-condition-box flex-between">
      <div class="condition-left">
        <div class="head-top-box">
          <img :src="info.u_img" class="head-img" />
          <img
            :src="
              info.frame_img
                ? info.frame_img
                : 'https://guoxuewx.canpoint.net/static/zihuixue_images/frame/frame_0.png'
            "
            class="frame-img"
          />
        </div>
        <div class="name user-text">{{ info.u_name }}</div>
        <div class="user-text c-9">ID：{{ info.u_guid }}</div>
        <div class="user-num-text">
          <div class="user-num-item">
            历史学习天数：<span class="c-40b8ee">{{ info.join_days }}</span>
          </div>
          <div class="user-num-item">
            当前加入班级：<span class="c-40b8ee">{{ info.class_num }}</span>
          </div>
          <div class="user-num-item">
            家长绑定账号：<span class="c-40b8ee">{{ info.patriarch_num }}</span>
          </div>
        </div>
        <div class="user-button">
          <el-button type="primary" round>知识漏洞一览</el-button>
        </div>
      </div>
      <div class="condition-right">
        <div
          class="right-item flex-between"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="flex-row-start">
            <div class="subject-icon">
              <img :src="item.subject_img" alt="" />
            </div>
            <span class="ml-15">正确率：</span>
            <div class="correct-box">
              <div>
                <el-progress
                  :text-inside="true"
                  class="progress"
                  :stroke-width="26"
                  :percentage="item.correct_accuracy"
                ></el-progress>
              </div>
            </div>
          </div>
          <div class="ml-15">
            <!-- <span>最近一次得分率：</span>
            <span class="fs-16 c-bc4654">60.10%</span> -->
          </div>
          <div class="ml-15" v-if="item.is_true">
            <span>作答用时评估：</span>
            <span class="fs-16 c-40b8ee" >{{ item.scorer_rating.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      tabList: [
        { title: "小学", code: 11 },
        { title: "初中", code: 12 },
        { title: "高中", code: 13 },
      ],
      tabActive: 11,
      info: {},
      list: [],
    };
  },
  created() {
    this.getInfo();
    this.getSubjectStatistical();
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    // 获取班级列表
    getInfo() {
      this.onLoading();
      this.getRequest("/wenjiaoopne/kc/patriarch/getLearningCondition", {
        son_u_guid: this.user.sonIng.son_u_guid,
      })
        .then((result) => {
          this.loading.close();
          this.info = result.data;
        })
        .catch(() => {
          this.loading.close();
        });
    },

    getSubjectStatistical() {
      this.getRequest("/wenjiaoopne/kc/patriarch/getSubjectStatistical", {
        stage_code: this.tabActive,
        son_u_guid: this.user.sonIng.son_u_guid,
      })
        .then((result) => {
          this.list = result.data;
        })
        .catch(() => {});
    },

    onSelectTab(c) {
      console.log(c);
      this.tabActive = c;
      this.getSubjectStatistical();
    },
    onLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
      });
    },
  },
};
</script>
<style scoped>
.p-condition-box {
  margin-top: 20px;
  min-height: 520px;
  background: #f3f6fe;
  padding: 20px;
  color: #333;
}
.p-condition-container .right-header {
  height: 130px;
  padding-top: 2px;
}
.p-condition-container .sign {
  width: 123px;
  height: 49px;
  margin-right: 10px;
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url("../../assets/images/3.png");
  color: #fff;
}
.p-condition-container .sign:first-child {
  margin-right: 10px;
}
.p-condition-container .active {
  background-image: url("../../assets/images/2.png");
}
.p-condition-container .right-header-text {
  color: #bcc8dd;
  margin-left: 10px;
}
.p-condition-container .num {
  display: inline-block;
  color: #40b8ee;
}

.p-condition-container .circle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-top: 2px;
  background-color: #40b8ee;
  vertical-align: middle;
}
.condition-left {
  width: 220px;
  height: 520px;
  background-color: #fff;
}
.condition-left .head-top-box {
  position: relative;
  width: 160px;
  height: 160px;
  margin: 20px auto 0 auto;
}
.condition-left .head-top-box > img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.condition-left .head-top-box .head-img {
  border-radius: 50%;
}
.condition-left .head-top-box .frame-img {
  z-index: 2;
}
.condition-left .user-text {
  text-align: center;
  margin: 5px 0;
}
.condition-left .user-num-text {
  margin: 50px 0;
  font-size: 14px;
}
.condition-left .user-num-text .user-num-item {
  width: 125px;
  margin: 4px auto;
}
.condition-left .user-button {
  text-align: center;
}

.condition-right {
  width: 625px;
  height: 520px;
  overflow-y: auto;
}

.right-item {
  background-color: #fff;
  padding: 10px 15px;
  margin-bottom: 10px;
  font-size: 14px;
}
.right-item .subject-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.right-item .subject-icon img {
  width: 100%;
  height: 100%;
}
.ml-15 {
  margin-left: 15px;
}
.fs-18 {
  font-size: 18px;
}
.correct-box {
  width: 130px;
}

.c-9 {
  color: #999;
}
</style>
